module.exports = __webpack_public_path__ + "static/media/jason.26f556f5.png";